/* src/app/self-enrollment/pdf/terms-short/termsShortPdf.component.css */
* {
  margin: 0;
  padding: 0;
  text-indent: 0;
}
h1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 20pt;
}
.s1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s2 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: italic;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
p {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 14pt;
  margin: 0pt;
}
.s3 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 14pt;
}
.s4 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 20pt;
}
.s5 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 14pt;
}
h2 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 14pt;
}
.s6 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
a {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: italic;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
table,
tbody {
  vertical-align: top;
  overflow: visible;
}
/*# sourceMappingURL=termsShortPdf.component.css.map */
